<template>
  <div>
    <v-expansion-panels v-if="hasHistory" :value="needsToBringPanelOpened(appointment.history.length)" accordion multiple>
      <v-expansion-panel v-for="history in appointment.history" :key="history.id">
        <v-expansion-panel-header class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="7">
              <h3 class="pt-2">
                {{ $t(history.action) }}
              </h3>
            </v-col>
            <v-col cols="12" sm="5" class="pr-5 text-right">
              <small class="overline grey--text text--lighten-1 transparent">
                {{ formatDate(history.date_created) }}
              </small>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-divider class="mb-6" />

          <h4 class="mb-5">
            {{ $t('appointment.history.label.appointmentData') }}
          </h4>

          <v-row>
            <v-col cols="12" md="3" sm="12">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.date') }}
              </h6>
              <span class="body-2">
                {{ formatDateWithSlot(history.date, history.slot_size || 0) }}
              </span>
            </v-col>
            <v-col cols="12" md="7" sm="12">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.status') }}
              </h6>
              <span class="body-2">
                {{ $t(history.status) }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8" md="3" sm="8">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.additionalAmount') }}
              </h6>
              <span class="body-2">
                {{
                  history.displacement.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                }}
              </span>
            </v-col>
            <v-col cols="4" md="2" sm="4">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.origin') }}
              </h6>
              <span class="body-2">
                {{ $t(history.source) }}
              </span>
            </v-col>
            <v-col cols="12" md="7" sm="12">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.observations') }}
              </h6>
              <span class="body-2">
                {{ history.observations ? history.observations : '---' }}
              </span>
            </v-col>
          </v-row>

          <v-row v-if="history.reschedule_reason">
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.rescheduleReason') }}
              </h6>
              <span class="body-2">
                {{ history.reschedule_reason }}
              </span>
            </v-col>
          </v-row>

          <v-row v-if="history.description">
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.description') }}
              </h6>
              <span class="body-2">
                {{ history.description }}
              </span>
            </v-col>
          </v-row>

          <!-- cancel info -->
          <div v-if="isCanceled(history.status)">
            <v-row>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('appointment.label.description') }}:
                </h6>
                <span class="body-2">
                  {{ history.description ? history.description : '---' }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h6 class="text-uppercase grey--text">
                  {{ $t('appointment.label.cancellationOrigin') }}:
                </h6>
                <span class="body-2">
                  {{ cancelReason }}
                </span>
              </v-col>
            </v-row>
          </div>
          <!-- /cancel info -->

          <v-divider class="my-8" />

          <h4 class="mb-5">
            {{ $t('appointment.history.label.authorData') }}
          </h4>

          <v-row>
            <v-col cols="6" sm="4">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.authorName') }}
              </h6>
              <span class="body-2">
                {{ getAuthorName(history.author) }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.authorPhone') }}
              </h6>
              <span v-if="history && history.author" class="body-2" v-html="whatsApp(history.author.phone)"></span>
            </v-col>
            <v-col>
              <h6 class="text-uppercase grey--text">
                {{ $t('appointment.history.label.authorEmail') }}
              </h6>
              <span v-if="history && history.author" class="body-2" v-html="mailto(history.author.username)">
              </span>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else class="d-flex justify-center white lighten-3 pa-5 grey--text">
      {{ $t('emptyState.noData') }}
    </div>
  </div>
</template>

<script>
import { mailto, whatsApp, catalogDate, catalogPhone, timeSlot } from '@/util/catalog'
import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentHistory',

  computed: {
    ...mapGetters(['appointment']),

    cancelReason() {
      return this.appointment?.cancel_reason
    },

    hasHistory() {
      return this.appointment?.history?.length > 0
    },
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },
    formatDateWithSlot(date, slotSize) {
      return timeSlot(date, slotSize)
    },
    formatPhone(phone) {
      return catalogPhone(phone)
    },
    needsToBringPanelOpened(length) {
      return length > 1 ? [] : [0]
    },
    getAuthorName(author) {
      return author ? author.name : '---'
    },
    getAuthorPhone(author) {
      return author ? author.phone : '---'
    },
    getAuthorUsername(author) {
      return author ? author.username : ''
    },
    isCanceled(status) {
      return status == 'Canceled'
    },
  },

  data() {
    return {
      mailto,
      whatsApp,
    }
  },
}
</script>
